// data/dummyIndia.js

export const indiaExportInvoices = [
  {
    id: "EXP001",
    date: "2026-06-01",
    customer: "Dubai Distributor LLC",
    country: "UAE",
    amount: 10000,
    currency: "USD",
    status: "LUT EXPORT",
  },
  {
    id: "EXP002",
    date: "2026-06-02",
    customer: "Abu Dhabi Digital Trading",
    country: "UAE",
    amount: 15000,
    currency: "USD",
    status: "LUT EXPORT",
  },

  {
    id: "EXP003",
    date: "2026-06-03",
    customer: "California SaaS Partners",
    country: "USA",
    amount: 25000,
    currency: "USD",
    status: "LUT EXPORT",
  },
  {
    id: "EXP004",
    date: "2026-06-03",
    customer: "Texas Growth Systems",
    country: "USA",
    amount: 18000,
    currency: "USD",
    status: "LUT EXPORT",
  },
  {
    id: "EXP005",
    date: "2026-06-04",
    customer: "New York Digital Inc",
    country: "USA",
    amount: 32000,
    currency: "USD",
    status: "LUT EXPORT",
  },

  {
    id: "EXP006",
    date: "2026-06-05",
    customer: "Paris Software SARL",
    country: "France",
    amount: 22000,
    currency: "EUR",
    status: "LUT EXPORT",
  },

  {
    id: "EXP007",
    date: "2026-06-05",
    customer: "London Tech Hub Ltd",
    country: "UK",
    amount: 28000,
    currency: "GBP",
    status: "LUT EXPORT",
  },

  {
    id: "EXP008",
    date: "2026-06-06",
    customer: "Singapore Digital Pte Ltd",
    country: "Singapore",
    amount: 19000,
    currency: "SGD",
    status: "LUT EXPORT",
  },

  {
    id: "EXP009",
    date: "2026-06-06",
    customer: "Sydney Cloud Services",
    country: "Australia",
    amount: 24000,
    currency: "AUD",
    status: "LUT EXPORT",
  },

  {
    id: "EXP010",
    date: "2026-06-07",
    customer: "Toronto SaaS Corp",
    country: "Canada",
    amount: 21000,
    currency: "CAD",
    status: "LUT EXPORT",
  },

  {
    id: "EXP011",
    date: "2026-06-07",
    customer: "Tokyo Digital KK",
    country: "Japan",
    amount: 35000,
    currency: "JPY",
    status: "LUT EXPORT",
  },

  {
    id: "EXP012",
    date: "2026-06-08",
    customer: "Seoul Growth Labs",
    country: "South Korea",
    amount: 27000,
    currency: "KRW",
    status: "LUT EXPORT",
  },

  {
    id: "EXP013",
    date: "2026-06-08",
    customer: "Moscow Tech Solutions",
    country: "Russia",
    amount: 16000,
    currency: "RUB",
    status: "LUT EXPORT",
  },

  {
    id: "EXP014",
    date: "2026-06-09",
    customer: "Karachi Digital Hub",
    country: "Pakistan",
    amount: 9000,
    currency: "PKR",
    status: "LUT EXPORT",
  },

  {
    id: "EXP015",
    date: "2026-06-09",
    customer: "Kathmandu Systems",
    country: "Nepal",
    amount: 7000,
    currency: "NPR",
    status: "LUT EXPORT",
  },

  {
    id: "EXP016",
    date: "2026-06-10",
    customer: "Dhaka Growth Partners",
    country: "Bangladesh",
    amount: 11000,
    currency: "BDT",
    status: "LUT EXPORT",
  },

  {
    id: "EXP017",
    date: "2026-06-10",
    customer: "Riyadh Digital Trading",
    country: "Saudi Arabia",
    amount: 30000,
    currency: "SAR",
    status: "LUT EXPORT",
  },

  {
    id: "EXP018",
    date: "2026-06-11",
    customer: "Tehran Software Co",
    country: "Iran",
    amount: 13000,
    currency: "IRR",
    status: "LUT EXPORT",
  },

  {
    id: "EXP019",
    date: "2026-06-11",
    customer: "Lagos Digital Ventures",
    country: "Nigeria",
    amount: 14000,
    currency: "NGN",
    status: "LUT EXPORT",
  },

  {
    id: "EXP020",
    date: "2026-06-12",
    customer: "Johannesburg Cloud Systems",
    country: "South Africa",
    amount: 17000,
    currency: "ZAR",
    status: "LUT EXPORT",
  },

  {
    id: "EXP021",
    date: "2026-06-12",
    customer: "Sao Paulo SaaS Ltda",
    country: "Brazil",
    amount: 26000,
    currency: "BRL",
    status: "LUT EXPORT",
  },

  {
    id: "EXP022",
    date: "2026-06-13",
    customer: "Buenos Aires Digital SA",
    country: "Argentina",
    amount: 18000,
    currency: "ARS",
    status: "LUT EXPORT",
  }
];